/**
 * Custom Fox — GA4 funnel tracking (start_designing).
 * GA4 property: G-T5SQ7WC4VG
 *
 * Zakeke PDP buttons (both can appear on the same page):
 *   1. #zakeke-product-button in .zakeke-product-button-container — "Customise"
 *   2. button.zakeke-product-button in shopify-app-block — "Customise and Order"
 */
(function () {
  var GA4_MEASUREMENT_ID = 'G-T5SQ7WC4VG';

  var ZAKEKE_SELECTOR =
    '#zakeke-product-button, ' +
    '.zakeke-product-button-container button, ' +
    '.zakeke-product-button, ' +
    'button[data-product-handle][data-product-id].zakeke-product-button, ' +
    '.cf-customise, ' +
    'a[href*="/apps/zakeke"]';

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  if (typeof window.gtag !== 'function') {
    window.gtag = gtag;
  }

  if (!window.__cfxGa4Loaded) {
    window.__cfxGa4Loaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_MEASUREMENT_ID;
    document.head.appendChild(script);
    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID, { send_page_view: false });
  }

  function getEntryPoint(el) {
    if (!el || !el.closest) return 'unknown';
    if (window.location.pathname.indexOf('/products/') === 0) return 'pdp';
    if (el.closest('[data-product-card-id]')) return 'collection_card';
    if (window.location.pathname === '/' || window.location.pathname === '') return 'homepage';
    if (el.closest(ZAKEKE_SELECTOR)) return 'zakeke';
    return 'other';
  }

  function getButtonSource(el) {
    if (!el) return 'unknown';
    if (el.id === 'zakeke-product-button' || el.closest('.zakeke-product-button-container')) {
      return 'zakeke_form_button';
    }
    if (el.classList.contains('zakeke-product-button') || el.closest('button.zakeke-product-button')) {
      return 'zakeke_app_block';
    }
    if (el.closest('.cf-customise')) return 'collection_customise';
    if (el.closest('a[href*="/apps/zakeke"]')) return 'zakeke_link';
    return 'text_match';
  }

  function isStartDesigningClick(el) {
    if (!el) return false;

    if (el.matches(ZAKEKE_SELECTOR) || el.closest(ZAKEKE_SELECTOR)) {
      return true;
    }

    var label = ((el.textContent || '') + ' ' + (el.getAttribute('aria-label') || ''))
      .replace(/\s+/g, ' ')
      .trim();

    return (
      /start\s*designing/i.test(label) ||
      /customise\s*this/i.test(label) ||
      /customise\s*and\s*order/i.test(label) ||
      /^customise$/i.test(label)
    );
  }

  function sendStartDesigningEvent(el) {
    var params = {
      page_location: window.location.href,
      entry_point: getEntryPoint(el),
      button_source: getButtonSource(el),
    };

    try {
      window.gtag('event', 'start_designing', Object.assign({ send_to: GA4_MEASUREMENT_ID }, params));
    } catch (e) {}

    window.dataLayer.push({
      event: 'start_designing',
      page_location: params.page_location,
      entry_point: params.entry_point,
      button_source: params.button_source,
    });

    // Always visible while verifying — remove later if desired
    console.log('[CFX funnel] start_designing fired', params);
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target.closest('a, button');
      if (!el || !isStartDesigningClick(el)) return;
      sendStartDesigningEvent(el);
    },
    true
  );

  // Manual test from DevTools: __cfxFunnelTest()
  window.__cfxFunnelTest = function () {
    sendStartDesigningEvent(document.querySelector(ZAKEKE_SELECTOR) || document.body);
    return 'sent start_designing';
  };

  console.log('[CFX funnel] loaded — click Customise, or run __cfxFunnelTest()');
})();
